import React from 'react';
import s from './AboutUs.module.css';
import puzzles from '../../assets/img/puzzless.png';
import puzzlesMobile from '../../assets/img/mobile/puzzless.png';
import ai_img from '../../assets/img/ai_img.png';
import future_finance from '../../assets/img/future_finance.png';
import BTC from '../../assets/img/BTC.png';
import CustomBtnPink from '../../components/ui/customBtnPink/CustomBtnPink';
import { OPEN_ACCOUNT } from '../../router/Constants';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Hero from '../../components/hero/Hero';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
  const navigate = useNavigate();

  // 2) Grab translation function
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>

      <motion.div
        initial={{ opacity: 0, scale: 1 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className={s.motion_div}
      >
        {/* Hero section */}
        <div className={s.content}>
          <Hero
            title_1={t('aboutUsPage.heroTitle1')}
            title_2={t('aboutUsPage.heroTitle2')}
            description={t('aboutUsPage.heroDescription')}
          />
        </div>

        {/* Paragraphs 1 & 2 */}
        <div className={s.content}>
          <div className={s.flex}>
            <div className={s.left}>
              <img src={ai_img} alt="ai" />
            </div>
            <div className={s.right}>
              <p>{t('aboutUsPage.paragraph1')}</p>
              <p>{t('aboutUsPage.paragraph2')}</p>
            </div>
          </div>
        </div>

        {/* Your Global Financial Partner */}
        <div className={s.content}>
          <div className={s.puzzles_block}>
            <div className={s.flex}>
              <div className={s.puzzles_img_block}>
                <img className={s.puzzles_mob} src={puzzlesMobile} alt="" />
                <img className={s.puzzles} src={puzzles} alt="" />
              </div>
              <div className={s.puzzles_description_block}>
                <h2 className={s.puzzles_block_title}>
                  {t('aboutUsPage.yourGlobalTitle')}
                </h2>
                <div className={s.puzzles_description_content}>
                  {t('aboutUsPage.yourGlobalIntro')}
                </div>
                <div className={s.puzzles_description_content}>
                  <div className={s.puzzles_description_row}>
                    <span className={s.bold}>
                      {t('aboutUsPage.unparalleledFlexibilityTitle')}{' '}
                    </span>
                    {t('aboutUsPage.unparalleledFlexibilityDesc')}
                  </div>
                  <div className={s.puzzles_description_row}>
                    <span className={s.bold}>
                      {t('aboutUsPage.enhancedPrivacyTitle')}{' '}
                    </span>
                    {t('aboutUsPage.enhancedPrivacyDesc')}
                  </div>
                  <div className={s.puzzles_description_row}>
                    <span className={s.bold}>
                      {t('aboutUsPage.strategicAdvantagesTitle')}{' '}
                    </span>
                    {t('aboutUsPage.strategicAdvantagesDesc')}
                  </div>
                </div>
                <div className={s.puzzles_button_block}>
                  <div className={s.button_wrapper}>
                    <CustomBtnPink
                      title={t('aboutUsPage.signUpBtn')}
                      onClick={() => navigate(OPEN_ACCOUNT)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Specializing in the Future of Finance */}
        <div className={s.content}>
          <div className={s.flex}>
            <div className={s.left}>
              <p className={s.bold}>{t('aboutUsPage.specFinTitle')}</p>
              <p>{t('aboutUsPage.paragraph3')}</p>

              <p>
                <span className={s.bold}>
                  {t('aboutUsPage.digitalAssetEscrowTitle')}
                </span>{' '}
                {t('aboutUsPage.digitalAssetEscrowDesc')}
              </p>
              <p>
                <span className={s.bold}>
                  {t('aboutUsPage.globalRealEstateTitle')}
                </span>{' '}
                {t('aboutUsPage.globalRealEstateDesc')}
              </p>
            </div>
            <div className={s.right}>
              <img src={future_finance} alt="ai" />
            </div>
          </div>
        </div>

        {/* Final paragraph about crypto & blockchain */}
        <div className={s.coin_block}>
          <div className={s.content}>
            <div className={s.text}>
              <p>{t('aboutUsPage.paragraph4')}</p>
              <div className={s.coin}>
                <img src={BTC} alt="" />
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default AboutUs;
